<template>
    <div class="card">
      <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Performance Appraisal Approval List"
                btnTitle="Add New"
                :showAddNew="false"
            />
        </div>

      <div class="my-2 px-2">
        <div class="row">
             <div class="col-12 col-sm-6 col-md-4">
                <label for="colFormLabel" class="col-form-label">Appraisal Period <span class="required">*</span></label>
                    <AsyncSelect
                        placeholder="Select Appraisal Period"
                        v-model="apprisalSetup"
                        :autoSelectFirst="true"
                        :api-service="fetchPerformanceApprisalSetupDropdown"
                    />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                  <label for="colFormLabel" class="col-form-label">Employee</label>
                  <AsyncSelect
                      placeholder="Select Employee"
                      v-model="contactProfileId"
                      :api-service="fetchContactProfiles"
                      :additional-query="{roles: 'employee', status: 'active'}"
                      label="name"
                      :reduce="name => name.id"
                  />
                </div>

                <div class="col-sm-2 col-md-2 d-flex m-0 align-items-end action-btn-setter">
                  <button
                      style="min-width: 64px;"
                      @click="getApprisalData"
                      class="btn btn-primary btn-block waves-effect waves-float waves-light"
                  >GO
                  </button>
                </div>
        </div>
      </div>

      <div class="row p-2">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>Employee Name & ID</th>
              <th>Designation</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in tableItems" :key="index">
              <td>{{ item.employee_name }} ({{ item.serial_no }})</td>
              <td>{{ item.employee_designation }}</td>
              <td>
                <button class="btn btn-primary btn-sm"
                        @click="goToEdit(item)"
                        style="cursor: pointer"
                >
                  <i class="fas fa-eye"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  <Loader v-if="loading"/>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref, watch} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleDropDown from "@/services/modules/dropdowns";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from '@/services/modules/contact'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const contactProfileId = ref('');
const apprisalSetup = ref('')
const tableItems = ref([]);
const params = ref({
    offset: 10,
});
const contactProfile = ref({})
const { fetchContactProfiles } = handleContact()
const token = computed(() => localStorage.getItem('token'));

const {
  fetchPerformanceAppraisalApproval
} = handleHrPayroll()
const { fetchPerformanceApprisalSetupDropdown } = handleDropDown();

const getApprisalData = async () => {
  const query = getQuery();
  loading.value = true
  tableItems.value = []
  await fetchPerformanceAppraisalApproval(query).then(res => {
    if (!res.status){
      return
    }
    tableItems.value = res.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.performance_apprisal_setup_id = item.performance_apprisal_setup_id;
  query.contact_profile_id = item.contact_profile_id;

  router.push({
    name:  'performance-appraisal',
    params: param,
    query: query
  })
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  if(apprisalSetup.value) query += `&performance_apprisal_setup_id=` + apprisalSetup.value.id
  if (contactProfileId.value) query += '&user_contact_profile_id=' + contactProfileId.value
  return query;
}

watch(apprisalSetup, async (newVal) => {
  if (newVal) {
    await getApprisalData();
  }
}, { immediate: true });

</script>

<style>
  .profile-info p{
    line-height: 1rem !important;
  }
</style>